import { useEffect } from "react";
import { useRouteError, useNavigate } from "react-router-dom";
import * as Sentry from "@sentry/react";
import heroImage from "../../assets/images/hero_gray.png";

/**
 * React Router 라우트 에러 발생 시 표시하는 유저 친화적 폴백 UI.
 * createBrowserRouter의 errorElement로 사용.
 */
export default function RouteErrorFallback() {
  const error = useRouteError();
  const navigate = useNavigate();

  useEffect(() => {
    const exception = error instanceof Error ? error : new Error(String(error));
    Sentry.captureException(exception);
  }, [error]);

  if (process.env.NODE_ENV === "development") {
    console.error("Route error:", error);
  }

  const handleReload = () => {
    window.location.reload();
  };

  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <div className="w-full min-h-screen flex justify-center items-center bg-[#fff]">
      <div className="relative w-full max-w-sm p-4 text-center">
        <img
          src={heroImage}
          alt="오류"
          className="mx-auto w-2/4 max-w-xs h-auto opacity-50 mt-0"
        />
        <p className="text-[#464646] text-lg font-semibold mb-8 mt-8">
          문제가 발생했습니다. <br />
          잠시 후 다시 시도해주세요.
        </p>
        <div className="flex flex-col gap-3 items-center">
          <button
            onClick={handleGoBack}
            className="w-32 h-10 bg-white rounded-md border border-solid border-[#dddddd] flex justify-center items-center cursor-pointer text-[#5b5b5b] text-sm font-semibold hover:bg-gray-50"
          >
            뒤로 가기
          </button>
          <button
            onClick={handleReload}
            className="w-32 h-10 bg-white rounded-md border border-solid border-[#dddddd] flex justify-center items-center cursor-pointer text-[#5b5b5b] text-sm font-semibold hover:bg-gray-50"
          >
            새로고침
          </button>
        </div>
      </div>
    </div>
  );
}
